import React, { useEffect, useState } from 'react';

import { Box, Paper, TextareaAutosize, Typography } from '@mui/material';

import { Reason } from '../../../../../common/constants/reasons';
import { Resource } from '../../../../../common/constants/resource';
import { CriminalRecords } from '../../../../tasks/types/criminalRecords';
import { LabPiqture } from '../../../../tasks/types/labPiqture';
import { MedicalClaims } from '../../../../tasks/types/medicalClaims';
import { ScriptCheck } from '../../../../tasks/types/scriptCheck';
import { ReasonsChoicePanel } from '../../ReasonsChoicePanel';
import { RequiredFieldErrorBar } from '../../RequiredFieldErrorBar';
import styles from '../../styles.module.scss';

type TaskData = LabPiqture | MedicalClaims | ScriptCheck | CriminalRecords;

export const SimpleLayout = ({
  data,
  setData,
  isExpanded,
  reasons,
  error,
  description,
}: {
  data: TaskData;
  setData: React.Dispatch<React.SetStateAction<TaskData>>;
  isExpanded: boolean;
  reasons?: Reason[];
  error: boolean;
  description: string;
}) => {
  const [reasonDescription, setReasonDescription] = useState(
    data.reasonDescription || '',
  );
  const [selectedReasons, setSelectedReasons] = useState(
    data.reason || ([] as string[]),
  );
  const [id] = useState(Math.random().toFixed(6).substring(2));

  useEffect(() => {
    const newData = {} as TaskData;
    if (isExpanded) {
      newData.reason = selectedReasons;
      newData.reasonDescription = reasonDescription;
    } else {
      setReasonDescription('');
      setSelectedReasons([] as string[]);
    }
    setData(newData);
  }, [isExpanded, reasonDescription, selectedReasons.length]);

  return (
    <Box>
      {error && (
        <Box mb={1}>
          <RequiredFieldErrorBar />
        </Box>
      )}

      <Box>
        <Typography variant="subtitle1" color="textSecondary" gutterBottom>
          {Resource.DESCRIPTION}
        </Typography>
      </Box>
      <Box>
        <Typography variant="body2">{description}</Typography>
      </Box>

      <Box mt={3}>
        <Paper
          elevation={0}
          style={{ backgroundColor: 'var(--neutrals-night-10)' }}
        >
          <Box p={1.5} pt={1.5}>
            <Typography variant="subtitle1" color="textSecondary" gutterBottom>
              {Resource.ORDER_REASON}
            </Typography>
            {reasons ? (
              <ReasonsChoicePanel
                reasons={reasons}
                selectedReasons={selectedReasons}
                selectReasonsCallback={setSelectedReasons}
              />
            ) : (
              <></>
            )}

            <Box mt={2}>
              <TextareaAutosize
                name="reason"
                data-tid={`${id}-reason-textarea`}
                placeholder="Describe the reason"
                className={styles.MUTextareaInput}
                onChange={(ev: React.ChangeEvent<HTMLTextAreaElement>) => {
                  setReasonDescription(ev.currentTarget.value);
                }}
                value={reasonDescription}
                minRows={3}
              />
            </Box>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};
